import type { OpportunityType } from '@/types/Opportunity'

const OPPORTUNITY_PATHS: Record<OpportunityType, string> = {
  dibbs_contract: '/dibbs-contracts',
  federal_contract: '/federal-contracts',
  federal_grant: '/federal-grants',
  sbir: '/sbirs',
  sled_contract: '/sled-contracts',
}

/**
 * Build an opportunity detail URL from type and ID.
 *
 * @example
 * const href = buildOpportunityUrl('123', 'federal_contract') // '/federal-contracts/123'
 */
export function buildOpportunityUrl(
  id: string,
  type: OpportunityType,
  searchId?: string | null,
): string {
  const url = `${OPPORTUNITY_PATHS[type]}/${id}`
  return searchId ? `${url}?search-id=${searchId}` : url
}

/**
 * @deprecated Import `buildOpportunityUrl` directly instead.
 */
export const useOpportunityUrl = () => {
  return { buildUrl: buildOpportunityUrl }
}
